import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {Keys, StorageService} from '../service/storage.service';

@Injectable()
export class UserIdResolver implements Resolve<string> {
    constructor(private storageService: StorageService) {
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): string {
        return this.storageService.getItem(Keys.PROFILE_ID);
    }
}